const showPaymentByCard = () => {
    const btnByCard = document.querySelectorAll('.payment-input'),
          paymentBlock = document.querySelector('.payment-card');

    if(btnByCard && paymentBlock) {
        var prev = null;
        for (let i = 0; i < btnByCard.length; i++) {
            btnByCard[i].addEventListener('change', function() {
                (prev) ? (prev.value): null;
                if (this !== prev) {
                    prev = this;
                }
                if(this.value == 2) {
                    paymentBlock.style.display = 'flex';
                } else {
                    paymentBlock.style.display = 'none';

                }
            });
        }
        const icon = paymentBlock.querySelector('svg');
        icon.addEventListener('mouseover', () => {
            icon.nextElementSibling.style.visibility = 'visible';
            icon.nextElementSibling.style.opacity = 1;
        })
        icon.addEventListener('mouseleave', () => {
            icon.nextElementSibling.style.visibility = 'hidden';
            icon.nextElementSibling.style.opacity = 0;
        })

    }
}

export default showPaymentByCard;